import { makeStyles } from "@material-ui/core/styles";
import { Black } from "../../shared/styles/colors";

export default makeStyles(() => ({
  card: {
    width: "100% !important",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    padding: "1rem",
    "@media (max-width:600px)": {
      padding: "0.5rem",
          boxShadow: "1px 2px 4px rgba(0, 0, 0, 0.3)",
    },
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    "@media (max-width: 640px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  headerDiv: {
    display: "flex",
    flexDirection: "row",
    width: "auto",
  },
  groupedItems: {
    display: "flex",
    flexDirection: "row",
    width: "50%",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "700",
    wordWrap: "break-word",
    color: Black,
  },
  limitedText: {
    display: "block",
    width: "180px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  clockStyle: {
    border: "none",
    "& div, input": {
      border: "none",
    },
  },
}));
